export default __webpack_public_path__ + "static/media/loader.9966b4e9.svg";